import { render, staticRenderFns } from "./FilterEndemicGroup.vue?vue&type=template&id=f61e05b0&"
import script from "./FilterEndemicGroup.vue?vue&type=script&lang=js&"
export * from "./FilterEndemicGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports